function trackCommissionFactoryPurchase(data, store) {
  // This line is from commission factory. Didn't feel like refactoring.
  (function(a, b, c) { a[b] = a[b] || function() { (a[b].q = a[b].q || []).push(arguments) }; a[c] = a[b] })(window, 'CommissionFactory', 'cf')

  const order = data.transaction

  // Just be safe, don't crash.
  if (!order.coupons) order.coupons = []
  if (!order.payment) order.payment = {}
  if (!order.items) order.items = []
  if (!order.address) order.address = {}
  if (!order.address.billing) order.address.billing = {}
  if (!data.currency) data.currency = 'AUD'
  if (!order.account) order.account = {}

  const systemRoles = store.getters['config/variable_get']('system_roles')
  const memberships = []
  if (store.getters['user/hasAnyRole'](systemRoles.wine_clubs)) memberships.push('club')
  if (store.getters['user/hasAnyRole'](systemRoles.rewards)) memberships.push('rewards')

  let hasPurchasedBefore = store.getters['config/getCookie']('hasPurchased')
  if (hasPurchasedBefore === null && order.account.id > 1) {
    hasPurchasedBefore = !order.first
  }

  cf('set', 'order', order.txnid)
  cf('set', 'amount', order.total)
  cf('set', 'coupon', order.coupons.map(coupon => coupon.code).join(', '))
  cf('set', 'currency', data.currency)
  cf('set', 'customer', hasPurchasedBefore ? 'return' : 'new')
  cf('set', 'date', order.payment.date ? order.payment.date.split('T').shift() : '')
  cf('set', 'signature', order.commissionFactorySignature)
  cf('set', 'timestamp', order.commissionFactoryTimestamp)
  cf('set', 'reference', hasPurchasedBefore ? 'return' : 'new')
  cf('set', 'reference2', memberships.join(''))
  cf('set', 'reference3', `${order.address.billing.city}, ${order.address.billing.state}, ${order.address.billing.postcode}, ${order.address.billing.country}`)
  cf('set', 'reference4', 'checkout')

  for (const item of order.items) {
    cf('add', 'items', {
      sku: item.sku,
      price: item.unitprice,
      quantity: item.qty,
      reference: `${item.nid}`,
      reference2: `${item.product.type}`,
      reference3: item.producer ? item.producer : 'N/A',
      reference4: `${item.product && item.product.varietal ? item.product.varietal.join(' ') : 'N/A'}`
    })
  }

  cf('track')
}

export default (eventHub, { enabled, advertiserId }, store) => {
  if (enabled && advertiserId) {
    eventHub.$on('eventReport', (val) => {
      if (val.event === 'purchase_paid' && val.source === 'commissionfactory') trackCommissionFactoryPurchase(val.ecommerce, store)

      if (val.event === 'purchase_paid') document.cookie = `hasPurchased=true; max-age=315360000; path=/`
    })

    eventHub.$on('mainWrapMounted', () => {
      const commissionFactoryScript = document.createElement('script')
      commissionFactoryScript.setAttribute('src', `https://t.cfjump.com/tag/${advertiserId}`)
      commissionFactoryScript.setAttribute('async', true)
      document.head.appendChild(commissionFactoryScript)
    })
  }
}
